// Czcionki i dzielenie długich słów dla generatorów PDF (react-pdf rejestruje globalnie).
// Roboto z plików w repo (src/assets/fonts, Apache 2.0) zamiast z CDN: PDF generuje się także, gdy CDN nie działa.
import { Font } from "@react-pdf/renderer";

export const ROBOTO_SOURCES = [
  { src: require("../../../assets/fonts/roboto-light.ttf"), fontWeight: 300 },
  { src: require("../../../assets/fonts/roboto-regular.ttf"), fontWeight: 400 },
  { src: require("../../../assets/fonts/roboto-medium.ttf"), fontWeight: 500 },
  { src: require("../../../assets/fonts/roboto-bold.ttf"), fontWeight: 600 },
];

Font.register({ family: "Roboto", fonts: ROBOTO_SOURCES });

const HYPHENATE_EVERY = 18;
Font.registerHyphenationCallback((word) =>
  word.length <= HYPHENATE_EVERY
    ? [word]
    : word.match(new RegExp(`.{1,${HYPHENATE_EVERY}}`, "g")) ?? [word]
);
